import { candidateIdFileIdGet } from "#candidate/services/api"
import ButtonIcon from "#common/buttons/ButtonIcon"
import { ViewPdfDialog } from "#core/components/view-pdf/ViewPdf"
import DeleteIcon from "@mui/icons-material/Delete"
import VisibilityIcon from "@mui/icons-material/Visibility"
import { Stack } from "@mui/material"
import { Fragment, useCallback, useMemo, useState } from "react"
import { CandidateFileFormDialog } from "./CandidateFileForm"
import CandidateFileButtonsDialogDelete from "./candidate-file-buttons-dialog/CandidateFileButtonsDialogDelete"
import { useCandidateRedux } from "#candidate/redux/slice"

export default function CandidateFileButtons({ data }) {
	const { candidate } = useCandidateRedux()
	const [open, setOpen] = useState(false)
	const paramsDialog = useCallback(
		(name) => ({ open: open === name, setOpen, data }),
		[data, open]
	)
	const params = useMemo(
		() => ({
			candidateId: data.candidate,
			fileId: data.id,
		}),
		[data.candidate, data.id]
	)
	const is_edit = candidate.is_enabled && candidate.vacancy_active

	return (
		<Fragment>
			<Stack
				direction={"row"}
				spacing={1}
				justifyContent={"center"}
				alignContent={"center"}
				width={"100%"}
			>
				{/* <ButtonIcon
					title="Editar"
					icon={<EditIcon />}
					onClick={() => setOpen("editar")}
				/> */}
				{is_edit && (
					<ButtonIcon
						title="Borrar"
						icon={<DeleteIcon />}
						onClick={() => setOpen("borrar")}
					/>
				)}
				<ButtonIcon
					title="Ver"
					icon={<VisibilityIcon />}
					onClick={() => setOpen("pdf")}
				/>
			</Stack>
			<CandidateFileFormDialog {...paramsDialog("editar")} />
			<CandidateFileButtonsDialogDelete {...paramsDialog("borrar")} />
			<ViewPdfDialog
				{...paramsDialog("pdf")}
				apiGet={candidateIdFileIdGet}
				moreParams={params}
			/>
		</Fragment>
	)
}
